import { CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostMoneyOut } from '@festina/life-general-types/life/hooks/CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostMoneyOut'

export const useLazyFetchCommitmentMoneyOutSimulation =
  CommitmentSourcesSimulateService_commitmentSourcesSimulateServicePostMoneyOut.useLazyQuery
